import { render, staticRenderFns } from "./RedemptionContribuitions.vue?vue&type=template&id=10002b52"
import script from "./RedemptionContribuitions.vue?vue&type=script&lang=js"
export * from "./RedemptionContribuitions.vue?vue&type=script&lang=js"
import style0 from "./RedemptionContribuitions.vue?vue&type=style&index=0&id=10002b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports